import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    this.currentMode = this.getPreferredMode()
    this.applyMode(this.currentMode)
  }

  pick(event) {
    const mode = event.params.mode
    this.currentMode = mode
    this.applyMode(mode)
    localStorage.setItem("color-mode", mode)
  }

  applyMode(mode) {
    if (mode === "auto") {
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
      document.documentElement.setAttribute("data-bs-theme", prefersDark ? "dark" : "light")
      this.autoListener()
    } else {
      document.documentElement.setAttribute("data-bs-theme", mode)
      this.removeAutoListener()
    }
    this.updateIcon()
  }

  autoListener() {
    this.removeAutoListener()
    this._mediaQuery = window.matchMedia("(prefers-color-scheme: dark)")
    this._handler = (e) => {
      document.documentElement.setAttribute("data-bs-theme", e.matches ? "dark" : "light")
    }
    this._mediaQuery.addEventListener("change", this._handler)
  }

  removeAutoListener() {
    if (this._mediaQuery && this._handler) {
      this._mediaQuery.removeEventListener("change", this._handler)
      this._mediaQuery = null
      this._handler = null
    }
  }

  updateIcon() {
    if (!this.hasIconTarget) return
    const icons = { light: "bi-sun-fill", dark: "bi-moon-fill", auto: "bi-circle-half" }
    this.iconTarget.className = `bi ${icons[this.currentMode]}`
  }

  getPreferredMode() {
    return localStorage.getItem("color-mode") || "light"
  }

  disconnect() {
    this.removeAutoListener()
  }
}
